import { Link } from "react-router-dom";

const quickActions = [
	{ label: "افزودن کارگاه", to: "/workshop_add/" },
	{ label: "افزودن وبینار", to: "/admin_webinar_add/" },
	{ label: "مدیریت ویدیو کلیپ", to: "/dashboard/video-clips/" },
	{ label: "اسلایدر صفحه اصلی", to: "/dashboard/homepage-hero/" },
	{ label: "راهنمای عکس‌ها", to: "/dashboard/image-guidelines/" },
	{ label: "ردیف‌های صفحه اصلی", to: "/dashboard/homepage-carousels/" },
	{ label: "مدیریت دکترها", to: "/dashboard/doctors/" },
	{ label: "مدیریت کاربران", to: "/dashboard/users/" },
	{ label: "مدیریت پلن‌های اشتراک", to: "/dashboard/subscriptions/" },
	{ label: "افزودن مقاله", to: "/publication_add/" },
	{ label: "افزودن گفتگو", to: "/discussion_add/" },
];

export default function DashboardHome() {
	return (
		<section className="flex-1 bg-white border border-[#E2E8F0] rounded-[10px] p-6 sm:p-5">
			<div className="max-w-[720px]">
				<p className="font-Vazir-700 text-[14px] text-cta mb-3">خانه داشبورد</p>
				<h1 className="font-Vazir-800 text-[28px] sm:text-[22px] text-darkBlue leading-[1.7]">
					مدیریت محتوای سلامت روان
				</h1>
				<p className="font-Vazir-400 text-[15px] text-midGray leading-[2.1] mt-5">
					روانشناسی به ما کمک می‌کند احساسات، افکار و رفتارهای انسان را بهتر بشناسیم. وقتی آگاهی روانی بیشتر می‌شود، ارتباط با خود و دیگران سالم‌تر می‌شود و تصمیم‌های روزمره با آرامش و شناخت بیشتری گرفته می‌شوند.
				</p>
			</div>

			<div className="grid grid-cols-2 md:grid-cols-1 gap-3 mt-8">
				{quickActions.map((item) => (
					<Link
						key={item.to}
						to={item.to}
						className="flex items-center justify-center min-h-[48px] rounded-xl bg-lightCta text-darkBlue font-Vazir-700 text-[14px] hover:bg-lightBlue transition-colors"
					>
						{item.label}
					</Link>
				))}
			</div>
		</section>
	);
}
